import { deburr } from 'lodash-es'

export function generateSlugFromText(text: string) {
  if (!text) {
    return ''
  }

  return deburr(text)
    .toLowerCase()
    .replace(/\s/g, '-')
    .replace(/[^a-zA-Z0-9-]/g, '-')
    .trim()
    .replace(/^[-]/, '')
    .replace(/[-]$/, '')
}
